import type { JSX } from 'react';

export function MenuItemDivider(): JSX.Element {
  /**
   * We use margins instead of padding so that they collapse. This makes it easier for the
   * spacing to work when there are headers and dividers next to each other AND when they're
   * rendered individually.
   */

  return <hr className="bg-steel-200 mx-0 my-2 h-px border-0" />;
}
